var _style, _path, _defs, _path2, _path3, _defs2, _defs3, _g, _line, _line2, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuSweatshirt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000121248191891811859730000011812983729586944944_);fill:none;stroke:#000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000109724435462062475340000002452555306889288090_);fill:none;stroke:#000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{stroke:#000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st4{clip-path:url(#SVGID_00000000944813249886080260000007339934237035373487_);fill:none;stroke:#000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st5{clip-path:url(#SVGID_00000044164999429474737280000010697912367144500890_);fill:none;stroke:#000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:#FFFFFF;stroke:#000000;stroke-width:0.75;stroke-miterlimit:10;}\n\t\n\t\t.st7{fill:none;stroke:#000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:0.6552064,0.1310413;}\n\t.st8{fill:none;stroke:#000000;stroke-width:0.75;stroke-miterlimit:10;}\n\t.st9{stroke:#000000;stroke-width:0.75;stroke-miterlimit:10;}\n\t\n\t\t.st10{fill:none;stroke:#000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:0.6750833,0.1350166;}\n\t\n\t\t.st11{clip-path:url(#SVGID_00000037684078388468227640000017619762962217696396_);fill:none;stroke:#000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st12{clip-path:url(#SVGID_00000147905057943285444630000013291382582201154231_);fill:none;stroke:#000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#000000;stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st14{stroke:#000000;stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st15{clip-path:url(#SVGID_00000145042767701656661660000006929886397950148529_);fill:none;stroke:#000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st16{clip-path:url(#SVGID_00000166673076987758629280000013382009886634931594_);fill:none;stroke:#000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st17{fill:none;stroke:#000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:0.2772027,0.0554405;}\n\t\n\t\t.st18{fill:none;stroke:#000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:0.2856122,0.0571224;}\n\t.st19{stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.4999504,28.2552166c0.7836952,6.8470097,1.5141907,18.1856709,0.4081917,21.3047581H23.1612072 c-1.1059971-3.1190872-0.3755054-14.4577484,0.4081898-21.3047581"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000055702252718348514630000013078415731301576122_",
    points: "23.3921928,53.2266541 23.188097,49.5529633  46.9283104,49.5529633 46.7242126,53.2266541  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021801665598073902240000000195783376812129446_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000055702252718348514630000013078415731301576122_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000055702252718348514630000013078415731301576122_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.5628853,28.2545547c-0.8680534,3.3391533-2.8294029,9.620575-4.161377,15.3291779 c-0.7293262,3.1257744-2.4909611,10.0892181-4.3889351,10.9376221l-4.8086138-0.8463898 c-1.5362358-2.0058212,2.6982679-16.6589317,3.9657307-22.5730133c0.8346643-3.8946342,3.3710051-11.9743614,4.6557379-14.4100018 l0,0c0.3554955-0.5981865,0.889225-1.0672827,1.5265961-1.3464975c2.1839523-0.9567299,6.7372589-1.9794464,8.7475872-2.9008474"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.527504,28.2813206c0.8680534,3.3391514,2.7390137,9.5938091,4.0709877,15.302412 c0.7293282,3.1257744,2.4909592,10.0892181,4.3889351,10.9376221l4.8086128-0.8463898 c1.5362358-2.0058212-2.6982651-16.6589317-3.9657288-22.5730133c-0.8346672-3.8946342-3.371006-11.9743614-4.6557388-14.4100018 l0,0c-0.3554955-0.5981865-0.889225-1.0672827-1.5265961-1.3464975c-2.1839523-0.9567299-6.7345619-1.9794464-8.7448921-2.9008474 "
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000147210493038076726540000016893700585845617792_",
    points: "12.6082611,54.0713997 15.0125666,54.4945946  13.9130402,58.0792694 11.9632215,57.7360725 10.0133886,57.392868 10.2039547,53.648201  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000148655027466562951200000016437646228111903390_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147210493038076726540000016893700585845617792_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000148655027466562951200000016437646228111903390_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 12.6082611,54.0713997 15.0125666,54.4945946 13.9130402,58.0792694 11.9632215,57.7360725 10.0133886,57.392868  10.2039547,53.648201  "
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147210493038076726540000016893700585845617792_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000087414226797063274720000002365090994130458802_",
    points: "57.4144096,54.1427307 55.010231,54.5666504  56.110836,58.1509933 58.0605507,57.807209 60.0102806,57.4634209 59.8185883,53.718811  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000019662980666556521060000011046601767482873262_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000087414226797063274720000002365090994130458802_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000019662980666556521060000011046601767482873262_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 57.4144096,54.1427307 55.010231,54.5666504 56.110836,58.1509933 58.0605507,57.807209 60.0102806,57.4634209  59.8185883,53.718811  "
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000087414226797063274720000002365090994130458802_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 39.7338371,
    y1: 11.8574362,
    x2: 39.7314911,
    y2: 11.8597813
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.2626877,12.5994759c-0.5557137,1.1418533-3.177597,3.6950912-6.2280121,3.6950912 c-3.0480709,0-5.8317814-2.5147514-6.3898144-3.6566038l0.7771282-0.332696l0.8135929-0.4478254 c0.0023479,0,0.004694,0,0.0070419,0.0023327c0.07267,0.0281487,0.3399658,0.4900417,0.8511162,1.0293131 c0.004694,0.007041,0.009388,0.0117207,0.0163994,0.0187616c0.004694,0.0070267,0.011734,0.0164137,0.0187473,0.0234404 c0.0797386,0.0914459,0.2837238,0.3118448,0.6072903,0.567421c0.2555599,0.1992903,0.5885143,0.4220371,0.9917889,0.6119547 c0.0562706,0.0281353,0.1125412,0.0539227,0.1711578,0.079711c0.0703506,0.0304813,0.1407013,0.0586166,0.2133713,0.0867662 c0.0023499,0,0.0070152,0.0023327,0.0093613,0.0046787c0.1477432,0.0562706,0.3071632,0.1078606,0.4712791,0.1524096 c0.1664925,0.046896,0.3399963,0.0844049,0.5228577,0.1125393c0.0891266,0.0164146,0.1805458,0.0281353,0.2766838,0.0375233 c0.093792,0.0117207,0.1875839,0.0187473,0.2860718,0.0234404c0.002346,0,0.002346,0,0.002346,0 c0.0867233,0.004694,0.1758499,0.0070267,0.2672691,0.0070267h0.0422134 c1.1441994-0.0023327,2.0492401-0.3446589,2.7526398-0.7901516c0.0422173-0.0234413,0.084404-0.0515766,0.1265945-0.079711 c0.0070381-0.004694,0.0164261-0.009388,0.023468-0.0164146c0.5650444-0.3704615,0.8956528-0.7385769,0.9683495-0.8229809 c0.0046654-0.004694,0.0070114-0.0093737,0.0093613-0.0117207c0.002346-0.002347,0.0046921-0.004694,0.0046921-0.004694 c0.483017-0.51583,0.7502823-0.9589615,0.8370628-1.0246191c0.002346-0.002347,0.0046959-0.002347,0.0070419-0.002347 c0.0046921-0.002347,0.0093575-0.002347,0.0117073-0.002347L41.2626877,12.5994759z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.7279663,14.1106653c-0.4032745-0.1899176-0.7362289-0.4126644-0.9917889-0.6119547 c-0.3235664-0.2555761-0.5275517-0.475975-0.6072903-0.567421c0.1805439,0.1875849,0.3892517,0.3821821,0.6283836,0.5697536 C32.0363007,13.7214422,32.3598366,13.9324684,32.7279663,14.1106653z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.1159935,14.5467701c-0.1828613-0.0281343-0.3563652-0.0656433-0.5228577-0.1125393 C33.7596283,14.4787798,33.9354782,14.5162888,34.1159935,14.5467701z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 30.2602825,
    y1: 11.8490047,
    x2: 39.714386,
    y2: 11.8490047
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 31.3866158,
    y1: 13.1962624,
    x2: 38.5630302,
    y2: 13.1962624
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSweatshirt);
export default __webpack_public_path__ + "static/media/Menu_Sweatshirt.a4d577f0a8e25bef1e485f1c1b940df2.svg";
export { ForwardRef as ReactComponent };